<template>
    <div v-if="!onboardingCompleted.value" class="rounded-lg h-full p-4 flex flex-col gap-1 w-full" :class="isDark ? 'bg-black/70' : 'bg-white/80'">
        <div class="flex items-center justify-between">
            <h1 class="text-2xl mb-2 text-primary font-semibold">
                Velkommen til Conta Pro
            </h1>
            <UButton
                variant="ghost"
                color="white"
                size="sm"
                class="underline hover:no-underline"
                @click="onboardingCompleted.value = true"
            >
                Skjul guide
            </UButton>
        </div>

        <h2 class="text-base md:text-lg mb-2">Sett opp det viktigste først - så er du raskt i gang med regnskapet</h2>

        <ul class="grid grid-cols-2 mt-2">
            <li
                v-for="link in links"
                :key="link.label"
                class="underline hover:no-underline cursor-pointer my-2"
                @click="link.clickHandler()"
            >
                {{ link.label }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">

import {isDark} from '@/theme/theme.service'
import {useSetting} from '@/setting/setting.service'
import {SACC_IMPORT} from '@/subaccount'
import {ORG_SETTINGS} from '@/org-settings'
import {INCOMING_BALANCE} from '@/incoming-balance'
import {usePanelManager} from '@tritt/multipanel'
import {BOOKKEEPING_ACCOUNT} from '@/bookkeeping-account'
import {HELP} from '@/help'

const {setting: onboardingCompleted} = useSetting<boolean>('ONBOARDING_ORGANIZATION_COMPLETE')

const links = [
    {
        label: 'Importer kunder og leverandører',
        clickHandler: () => openSecondPanel(SACC_IMPORT.componentName)
    },
    {
        label: 'Se over virksomhetsinnstillinger',
        clickHandler: () => openSecondPanel(ORG_SETTINGS.componentName, {tab: 'general'})
    },
    {
        label: 'Aktiver EHF',
        clickHandler: () => openSecondPanel(ORG_SETTINGS.componentName, {tab: 'ehf'})
    },
    {
        label: 'Se over kontoplan',
        clickHandler: () => openSecondPanel(BOOKKEEPING_ACCOUNT.componentName)
    },
    {
        label: 'Importer inngående balanse',
        clickHandler: () => openSecondPanel(INCOMING_BALANCE.componentName)
    },
    {
        label: 'Sett opp betalingsoppfølging',
        clickHandler: () => openSecondPanel(ORG_SETTINGS.componentName, {tab: 'debtCollection'})
    },
    {
        label: 'Koble til bankkonto',
        clickHandler: () => openSecondPanel(ORG_SETTINGS.componentName, {tab: 'bank'})
    },
    {
        label: 'Lær systemets hurtigtaster',
        clickHandler: () => openSecondPanel(HELP.componentName)
    },

]
const {setPanelPath} = usePanelManager()

const openSecondPanel = async (componentName: string, queryValues?: Record<string, string>) => {
    await setPanelPath({
        componentName,
        panelId: 2,
        queryValues
    })
}

</script>


<style scoped>

</style>